module.exports = __webpack_public_path__ + "img/icon_monitor_size_16_hl.bf84f1af.webp";